import request from '@/utils/request'

export function GetFirstComplaintsHotline(deptName) {
  return request({
    url:'/api/BusinessCard/get-first-complaints-hotline?deptName='+deptName,
    method:'get',
  })
}

export function QueryAddress(deptName) {
  return request({
    url:'api/BusinessCard/query-address?deptName='+deptName,
    method:'get',
  })
}
